import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function ForkWithDelayBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editForkWithDelayBoxController',
    editElementModalTemplate: require('./editForkWithDelayBox.modal.html'),
    angularTemplate: `
  <div layout="column" class="list-picker-box-content">
    <div><span>{{ elementData.description ||  'parameters/quick_replies/details/graph/fork_with_delay_box/description_placeholder' | translate}}</span></div>
    <div ng-if="!!elementData.delay">
      <span>{{ 'parameters/quick_replies/details/graph/fork_with_delay_box/delay' | translate }}</span> : 
      <span>{{ elementData.delay.value }} {{ elementData.delay.unit }}</span>
    </div>
  </div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },
  });
}
